import service from './service';

export const findAll = listQuery => {
  return service.get('/v1/product', listQuery);
};

export const findListInfoOfProduct = query => {
  return service.get(`/v2/product/infos`, query);
};

/**
 * Thêm sản phẩm không cần sản xuất
 * @param {*} query
 * @returns
 */
export const saveInInfoOfProduct = productInfo => {
  return service.post(`/v2/product/info/in`, {
    productInfo
  });
};

/**
 * Xuất sản phẩm bỏ đi không cần sử dụng
 * @param {*} productInfo
 * @returns
 */
export const saveOutInfoOfProduct = productInfo => {
  return service.post(`/v2/product/info/out`, {
    productInfo
  });
};

export const saveReason = reason => {
  return service.post(`/v2/product/reason`, {
    reason
  });
};
export const findReason = query => {
  return service.get(`/v2/product/reasons`, query);
};

// export const findInfo = (productId, productSpecifyId, colorId) => {
//   return service.get(`/v1/product/info`, {
//     productId,
//     productSpecifyId,
//     colorId,
//   });
// };

export const saveProductInfo = productInfo => {
  return service.post(`/v1/product/info`, {
    productInfo
  });
};

export const saveConverUnitProductInfo = (productInfo, oldQuantity, newQuantity, newUnit) => {
  return service.post(`/v2/product/info/convert-unit`, {
    productInfo,
    oldQuantity,
    newQuantity,
    newUnit
  });
};

export const findAllHistoryProductInfo = (id, listQuery) => {
  return service.get(`/v1/product/info/${id}/history`, listQuery);
};

export const findQuota = id => {
  return service.get(`/v1/quota/product/${id}`);
};

export const update = (id, product) => {
  return service.post(`/v1/product/${id}/update`, { product });
};

export const create = product => {
  return service.post(`/v1/product`, { product });
};

export const updateSpec = (id, productId, spec) => {
  return service.post(`/v1/product/spec/${id}/update`, { productId, spec });
};

export const createSpec = (productId, spec) => {
  return service.post(`/v1/product/spec/`, { productId, spec });
};

export const findSpec = spec_id => {
  return service.get(`/v1/product/spec/${spec_id}`);
};

export const specSaveFeature = (feature, spec_id) => {
  return service.post(`/v1/product/spec/feature`, { feature, spec_id });
};
export const specFeatureRemoveList = list => {
  return service.post(`/v1/product/spec/feature/deletes`, list);
};
export const specFeatureRemoveParameter = id => {
  return service.post(`/v1/product/spec/parameter/${id}`);
};
export const specFeatureSaveParameter = (parameter, spec_id) => {
  return service.post(`/v1/product/spec/parameter/`, { parameter, spec_id });
};
